import React from 'react';

export const Navigation = ({
  disabled,
  loading,
  onPrev,
  onNext,
  submit
}: {
  disabled: boolean;
  loading?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  submit?: boolean;
}) => (
  <div className="form-navigation">
    {onPrev && (
      <button type="button" className="btn-nav btn-prev" onClick={onPrev}>
        <span className="arrow">←</span> Anterior
      </button>
    )}
    <button
      type={submit ? 'submit' : 'button'}
      className={`btn-nav ${submit ? 'btn-submit' : 'btn-next'}`}
      onClick={onNext}
      disabled={disabled || loading}
    >
      {loading ? 'Processando...' : submit ? 'Finalizar Inscrição' : <>Próximo <span className="arrow">→</span></>}
    </button>
  </div>
);

export const RadioOption = ({
  label,
  checked,
  onChange
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <label className="radio-option">
    <input type="radio" checked={checked} onChange={onChange} />
    <span className="radio-custom" />
    <span className="radio-text">{label}</span>
  </label>
);

export const YesNo = ({
  value,
  onChange
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) => (
  <div className="radio-group">
    <RadioOption label="✅ SIM" checked={value === true} onChange={() => onChange(true)} />
    <RadioOption label="❌ NÃO" checked={value === false} onChange={() => onChange(false)} />
  </div>
);

export const Question = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="form-group">
    <label className="question-label">{label}</label>
    {children}
  </div>
);

export const Textarea = ({
  id,
  label,
  value,
  onChange
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}) => (
  <div className="form-group">
    <label htmlFor={id}>{label}</label>
    <textarea id={id} placeholder="Descreva..." value={value} onChange={(event) => onChange(event.target.value)} />
  </div>
);

export const Detail = ({ label, value }: { label: string; value: string }) => (
  <div className="detail-item">
    <div className="detail-icon">✓</div>
    <div className="detail-content">
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value}</span>
    </div>
  </div>
);
